import { SAVED_SUCCESSFULLY_SURVEY } from '../../utils/surveyLiterals'

const initialState = {
    saveSurvey: { variant: undefined, description: undefined },
}

export default function saveReducer(state = initialState, action) {
    switch (action.type) {
        case SAVED_SUCCESSFULLY_SURVEY:
            return {
                ...state,
                saveSurvey: action.payload
            }
        default:
            return state
    }
}